import axiosTokenInstance from "services/api/backoffice";
import { LEAD, LEAD_ERROR } from "_models/redux/types";

// Action function
export const getLead = (params) => async (dispatch) => {
    const { lead_id } = params || {};

    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/callcenter/leads/${lead_id}`
        );

        const { data, status } = response || {};

        dispatch({
            type: LEAD,
            payload: data || {},
            status: status || {},
            method: "get",
        });
    } catch (e) {
        dispatch({
            type: LEAD_ERROR,
            payload: e || {},
        });
    }
};
